/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/member-delimiter-style */
import React, { useEffect, useState } from 'react'
import { Text } from '@tremor/react'
import { CircularProgress } from '@material-ui/core'

import { useApiCall } from 'hooks/useApi'

import { useLoadingTracker } from '../../hooks/useLoadingTracker'
import { getCohortAnalysis, CohortApiParams } from './api'
import HeatmapTable from '../../components/HeatmapTable'
import { montserratStyle } from '../../styles'

interface CohortApiResponse {
  columns: string[]
  rowLabels: { label: string; quantity: number }[]
  data: (number | null)[][]
}
interface CohortAnalysisTableProps {
  period: { month: number; year: number }
  storeId?: number
  trigger: number
  // eslint-disable-next-line react/require-default-props
  onLoaded?: () => void
}

const CohortAnalysisTable: React.FC<CohortAnalysisTableProps> = ({
  period,
  storeId,
  trigger,
  onLoaded,
}) => {
  const [data, setData] = useState<CohortApiResponse | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const [apiCall] = useApiCall<CohortApiParams, CohortApiResponse>(getCohortAnalysis)

  // Track loading state
  useLoadingTracker({ isLoading: loading, componentId: 'CohortAnalysisTable' })

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      setError(null)
      try {
        const endDate = new Date(period.year, period.month + 1, 0)
        const params: CohortApiParams = {
          endDate: endDate.toISOString().slice(0, 10),
        }
        if (storeId) params.storeId = storeId
        const response = await apiCall(params)
        setData(response)
      } catch (err) {
        setError('Error al cargar datos de cohortes')
      } finally {
        setLoading(false)
        if (onLoaded) {
          onLoaded()
        }
      }
    }
    if (trigger > 0) {
      fetchData()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger])

  const getFooterContent = () => {
    if (loading) {
      return (
        <div className="flex items-center justify-center">
          <CircularProgress size={40} />{' '}
        </div>
      )
    }
    if (error) {
      return (
        <div className="text-center py-4 text-red-500" style={{ ...montserratStyle }}>
          {error}
        </div>
      )
    }
    if (!data) {
      return (
        <Text className="text-center py-4">
          No hay datos disponibles para mostrar en este momento.
        </Text>
      )
    }
    return null
  }

  const getTableData = () => {
    if (loading || error || !data) {
      return { data: [], columns: [] }
    }
    return { data: data.data, columns: data.columns }
  }

  const { data: tableData, columns: tableColumns } = getTableData()

  return (
    <HeatmapTable
      data={tableData}
      columns={tableColumns}
      rowLabels={data?.rowLabels}
      title="Análisis de cohortes"
      footer={getFooterContent()}
    />
  )
}

CohortAnalysisTable.defaultProps = {
  storeId: undefined,
}

export default CohortAnalysisTable
